const getters = {
  reports: state => state.report,
  report: state => state.report_id,
};

export default getters;
